module.exports = __webpack_public_path__ + "static/media/turtle.4aa38165.svg";